import { useSupportEmail } from '../../../hooks';

export const SUPPORT_EMAIL = 'support@calefy.ca';

interface SupportLinkProps {
  subject?: string;
  body?: string;
}
export const SupportLink = ({ subject, body }: SupportLinkProps) => {
  const supportEmail = useSupportEmail();

  return (
    <a
      href={
        `mailto:${supportEmail}` +
        (subject || body
          ? `?${[
              subject ? `subject=${subject}` : '',
              body ? `body=${body}` : '',
            ]
              .filter((elem) => !!elem)
              .join('&')}`
          : '')
      }
    >
      {supportEmail}
    </a>
  );
};
